import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { AdminService } from '../../admin/admin.service';
import { ResultService } from '../../result/result.service';

@Component({
  selector: 'app-result',
  templateUrl: './result.component.html',
  styleUrls: ['./result.component.scss']
})
export class ResultComponent implements OnInit {
  public electionResultData: any;
  currentLanguage: 'en' | 'es' = 'en';
  content = {

  en: {

    login: 'Login',

    resultTitle: 'Election Results',

    sr: 'S.No',

    candidate: 'Candidate Name',

    votes: 'Votes',

    status: 'Status',

    noResult: 'No results available.',

    contact: 'Contact',

    copyright: 'All Rights Reserved.'

  },

  es: {

    login: 'Iniciar sesión',

    resultTitle: 'Resultados de las elecciones',

    sr: 'N.º',

    candidate: 'Nombre del candidato',

    votes: 'Votos',

    status: 'Estado',

    noResult: 'No hay resultados disponibles.',

    contact: 'Contacto',

    copyright: 'Todos los derechos reservados.'

  }

};
  constructor(private resultService: ResultService,
    private spinner: NgxSpinnerService, private adminService: AdminService) { }

 ngOnInit(): void {

  const lang = localStorage.getItem('language');

  if (lang === 'en' || lang === 'es') {
    this.currentLanguage = lang;
  }

  this.getResult();
  this.getActiveElection();
  this.getDesignations();

}

changeLanguage(lang: 'en' | 'es') {

  this.currentLanguage = lang;

  localStorage.setItem('language', lang);

}


  public electionData: any;
  getActiveElection() {
    this.adminService.getWithOutToken('get-active-election.json').subscribe((res: any) => {
      console.log(res);
      this.electionData = res.record;
    }, err => {
      console.log(err);
    });
  }

  public results: any = [];
  public designation = [];
  getResult() {
    this.spinner.show();
    this.resultService.get('get-result.json').subscribe((res: any) => {
      console.log(res)
      this.electionResultData = res;
       //this.designation = ['ICA-AP Regional Board Members', 'Chairman', 'ICA-AP Vice President', 'ICA-AP President','ICA Global Youth Member- Africa','ICA Global Youth Member at Large-Asia and Pacific','ICA Global Youth Member -Europe','ICA Global Youth Member -Americas','Youth Representative'];
      this.spinner.hide();
    }, err => {
      console.log(err);
      this.spinner.hide();
    });

    console.log(this.designation)
  }

  getDesignations() {
    this.spinner.show();
    this.adminService.getWithOutToken('get-designations.json').subscribe((res: any) => {
      console.log(res)
      if(res){
          //res.sort((a, b) => a.name.localeCompare(b.name));
          res.forEach(element => {
              this.designation.push(element.name);
          });
      }
      this.spinner.hide();
    }, err => {
      console.log(err);
      this.spinner.hide();
    })
  }

  // short(dgn) {
  //   if (!this.electionResultData || !this.electionResultData.record) {
  //     return [];
  //   }
  //   return this.electionResultData.record.filter(obj => obj.designation.name == dgn);
  // }

  short(dgn) {
    if (!this.electionResultData || !this.electionResultData.record) {
      return [];
    }

    // Filter by designation without changing order
    return this.electionResultData.record.filter(obj => obj.designation.name === dgn);
  }

// Function to check for duplicate total votes
hasDuplicateTotalVotes(arr: any[], vote: number, index: number): boolean {
  return arr.some((item, idx) => item.total_vote === vote && idx !== index);
}

// Function to check if the candidate is a winner
  is_winned(val, i) {
    if(val.total_vote > 0){
      var edl = this.electionResultData.election.election_details.find(x => x.designation == val.designation.id);

    if (edl) {
      if (i <= edl.no_of_posts) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
    }

  }

  is_vote_valid(total_vote: number): boolean {
    return total_vote > 1;
  }

 // Get the minimum vote count specifically for top candidates
  getMinimumVoteCount(): number | null {
    // Extract top candidates based on no_of_candidate limit
    const topCandidatesVotes = this.electionResultData.record
        .slice(0, this.electionResultData.no_of_candidate)
        .map(item => item.total_vote)
        .filter(vote => vote > 0); // Ignore 0 votes
    return topCandidatesVotes.length > 0 ? Math.min(...topCandidatesVotes) : null;
  }


  shouldShowCheckIcon(index: number): boolean {
    return index < this.electionResultData.election.no_of_candidate;
  }

  shouldShowTimesIcon(index: number, totalVote: any) {
    const electionDetails = this.electionResultData.election.election_details;
    const result = electionDetails.find(detail => Number(detail.designation) === totalVote.designation.id);
    return totalVote === 0 || index >= result.no_of_posts;
  }



getVoteColor(candidate: any, index: number) {
  const electionDetails = this.electionResultData.election.election_details.find(
    detail => Number(detail.designation) === Number(candidate.designation.id)
  );

  if (!electionDetails) {
    return { color: '#ffffff', statusIcon: '' };
  }

  const noOfPosts = electionDetails.no_of_posts;

  // All candidates for this designation
  const candidates = this.electionResultData.record.filter(
    record => record.designation.id === candidate.designation.id
  );

  // Sort by vote descending
  const sortedCandidates = [...candidates].sort((a, b) => b.total_vote - a.total_vote);

  // Votes of top N (no_of_posts) candidates
  const topCandidates = sortedCandidates.slice(0, noOfPosts);
  const cutoffVote = topCandidates[topCandidates.length - 1]?.total_vote;

  // Collect all candidates who have the same vote as the cutoff
  const tiedAtCutoff = sortedCandidates.filter(c => c.total_vote === cutoffVote);

  // If the tie at cutoff causes more than no_of_posts candidates with the same vote
  const startIndexOfTie = sortedCandidates.findIndex(c => c.total_vote === cutoffVote);
  const endIndexOfTie = startIndexOfTie + tiedAtCutoff.length - 1;

  const candidateIndex = sortedCandidates.findIndex(c => c.candidate_id === candidate.candidate_id);

  const isTiedWithCutoff = candidate.total_vote === cutoffVote;

  // Case 1, 2, 3: If candidate is part of tie that crosses cutoff limit
  if (isTiedWithCutoff && startIndexOfTie < noOfPosts && endIndexOfTie >= noOfPosts) {
    return { color: '#ffffff', statusIcon: '' }; // blank
  }

  // If within safe top N and not tied with cutoff
  if (candidateIndex < noOfPosts) {
    return { color: '#c3edc3', statusIcon: 'fa-check' }; // green with check
  }

  // Otherwise, not elected
  return { color: '#f8d7da', statusIcon: 'fa-times' }; // red with cross
}

}
